import ShareIcon from 'src/assets/icons/new-share.svg?react';
import Button from '@src/components/button/Button';
import styles from '../LessonProgressModal.module.scss';

type Props = {
  uniqueName: string;
  isCaregiver?: boolean;
  handleClickShare?: () => void;
};

export default function LinkShareIcon({ handleClickShare }: Props) {
  
  const handleClick = () => {
    handleClickShare?.();
  }

  return (
    <Button label='Share Lesson' size='small' className={styles.bannerShareButton} leftIcon={<ShareIcon  width={24} height={24} />} onClick={handleClick}/>
  );
}
